
import deepCopy from '@util/copy';
import { tripToTripMutation } from '@util/tripMapper';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Pilot, Tag, Trip, TripMutation } from '@clients/myTrips';
import { Component, Prop } from 'vue-property-decorator';
import TagSelect from '@components/new-styleguide/form/TagSelect.vue';
import PilotSelect from '@components/new-styleguide/form/PilotSelect.vue';

const SettingsModule = namespace('Settings');

@Component({
  name: 'TripDataPilotTag',
  components: {
    PilotSelect,
    TagSelect
  }
})

export default class TripDataPilotTag extends Vue {
  @Prop({ default: false })
  private addMode: boolean;

  @Prop()
  private trip: Trip;

  @Prop()
  private tripMutation: TripMutation;

  @Prop({ default: false })
  private loading: boolean;

  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  @SettingsModule.Getter('getPilots')
  private pilots: Pilot[];

  get tripId() {
    return this.addMode || this.loading ? null : String(this.trip.id)
  }

  get editMode() {
    return !!this.tripMutation;
  }

  get tag() {
    if (this.loading) {
      return null;
    }
    return this.editMode || this.addMode ? this.tripMutation.tagId && this.tags.find(t => t.id === this.tripMutation.tagId) : this.trip.tag;
  }

  get pilot() {
    if (this.loading) {
      return null;
    }
    return this.editMode || this.addMode ? this.tripMutation.pilotId && this.pilots.find(p => p.id === this.tripMutation.pilotId) : this.trip.pilot;
  }

  private handleTagChange(tag: Tag) {
    this.handleChange(tag && tag.id, 'tagId');
  }

  private handlePilotChange(pilot: Pilot) {
    this.handleChange(pilot && pilot.id, 'pilotId');
  }

  private handleChange(id: number, fieldName: string) {
    if (!this.editMode && !this.addMode) {
      const copy = tripToTripMutation(this.trip);
      copy[fieldName] = id ? id : null;
      this.$emit('input', copy);
      this.$emit('save');
    } else {
      const copy = deepCopy(this.tripMutation);
      copy[fieldName] = id ? id : null;
      this.$emit('input', copy);
    }
  }
}
